import styled from '@emotion/styled';
import { t } from 'services/translation';
import { Theme } from 'ui_system/theme';

const HeaderStyle = styled.h5`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
`;

const ContentStyle = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
`;

const AdditionalInfoButton = styled.a`
  display: inline-block;
  background-color: ${Theme.colors.linksDesignElementsBaseColor};
  color: ${Theme.colors.white};
  border: transparent;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  padding: 13px 32px;
  text-align: center;

  &:hover {
    color: ${Theme.colors.white};
  }
`;

const ScreenReader = styled.span`
  display: none;
`;

type AdditionalGuestsProps = {
  buttonText: string;
  heading: string;
  content: string;
  bookingIdHash: string;
  bookingLanguage: string;
};

const AdditionalGuestsLink = ({
  buttonText,
  heading,
  content,
  bookingIdHash,
  bookingLanguage,
}: AdditionalGuestsProps): JSX.Element => {
  const headerTranslation = t('BEFORE_YOU_ARRIVE');
  const contentTranslation = `${t(
    'IN_ORDER_TO_TAILOR_OUR_EXPERIENCES_TO_OUR_GUESTS_PREFERENCES'
  )} <b>${t(
    'WE_NEED_SOME_ADDITIONAL_INFORMATION_FROM_ALL_PARTICIPATING_GUETS'
  )}</b>`;
  const buttonTxtTranslation = t('COMPLETE_ADDITIONAL_INFORMATION');
  const headerTranslationKey = heading
    ? heading.toUpperCase().replaceAll(' ', '_')
    : null;
  const contentTranslationKey = content
    ? content.toUpperCase().replaceAll(' ', '_')
    : null;
  const buttonTxtTranslationKey = buttonText
    ? buttonText.toUpperCase().replaceAll(' ', '_')
    : null;
  const header =
    t(headerTranslationKey) === headerTranslationKey
      ? heading
      : t(headerTranslationKey);
  const message =
    t(contentTranslationKey) === contentTranslationKey
      ? content
      : t(contentTranslationKey);
  const buttonTxt =
    t(buttonTxtTranslationKey) === buttonTxtTranslationKey
      ? buttonText
      : t(buttonTxtTranslationKey);
  return (
    <>
      <hr className="separator" />
      <HeaderStyle data-testid="gog-section-heading">
        {header || headerTranslation}
      </HeaderStyle>
      <ContentStyle
        data-testid="confirmation-content"
        dangerouslySetInnerHTML={
          { __html: t(message) || contentTranslation } /* // nosemgrep */
        }
      />
      <AdditionalInfoButton
        className="GoGAdditionalInfoButton brand-bg"
        href={`/guest-information/${bookingIdHash}?lang=${bookingLanguage}`}
        target="_blank"
        data-testid="guest-information-page-btn"
      >
        {buttonTxt || buttonTxtTranslation}
        <ScreenReader className="screenreader-text">
          (Link opens in a new tab)
        </ScreenReader>
      </AdditionalInfoButton>
    </>
  );
};

export default AdditionalGuestsLink;
